<!-- Parité V1 : input useBrowserLocale supprimé de ngx-extended-pdf-viewer 29 (locale navigateur utilisée par défaut) -->
<!-- Parité V1 : outils d'annotation désactivés (absents de la version ngx-extended-pdf-viewer de ClientApp). -->
<ngx-extended-pdf-viewer [src]="sourceFile"  [filenameForDownload]="FileName" height="80vh"
  [showTextEditor]="false" [showStampEditor]="false" [showDrawEditor]="false"
  [showHighlightEditor]="false" [showSignatureEditor]="false">
</ngx-extended-pdf-viewer>
